import { defineStore } from 'pinia'
import { computed, ref, watch } from 'vue'
import useUrlStorage from '@app/shared/vue/composables/use-url-storage'

export const useInboxFiltersStore = defineStore('inboxFilters', () => {
  const noteType = useUrlStorage<string | number | null>(
    'noteType',
    null,
    (val) => (val === null ? '' : `${val}`)
  )
  const tags = useUrlStorage<string[]>('tags', [], (val) => val.join(','))
  const authors = useUrlStorage<string[]>('authors', [], (val) => val.join(','))
  const searchTerm = useUrlStorage<string>('searchTerm', '', (val) => val)
  const lastChanged = ref<number>(0)
  const receivedInitialValues = ref<boolean>(false)
  const anyFilterPresent = computed<boolean>(() => {
    return (
      noteType.value !== null ||
      tags.value.length > 0 ||
      authors.value.length > 0 ||
      searchTerm.value.length > 0
    )
  })

  function clearFilters(): void {
    noteType.value = null
    tags.value = []
    authors.value = []
    searchTerm.value = ''
    lastChanged.value = Date.now()
  }

  function receiveFilters(
    initialNoteType: string | number | null = null,
    initialTags: string[] = [],
    initialAuthors: string[] = [],
    initialSearchTerm: string = ''
  ): void {
    noteType.value = initialNoteType
    tags.value = initialTags
    authors.value = initialAuthors
    searchTerm.value = initialSearchTerm
    setTimeout(() => {
      receivedInitialValues.value = true
    })
  }

  function updateLastChange(): void {
    if (receivedInitialValues.value) {
      lastChanged.value = Date.now()
    }
  }

  watch(searchTerm, updateLastChange)
  watch(authors, updateLastChange, { deep: true })
  watch(tags, updateLastChange, { deep: true })
  watch(noteType, updateLastChange)

  return {
    anyFilterPresent,
    noteType,
    tags,
    authors,
    searchTerm,
    lastChanged,
    receivedInitialValues,
    clearFilters,
    receiveFilters,
  }
})
